import { styled } from "@mui/material";
import { Router } from "../../routes/Routes";

const ViewPort = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.surfaceLight20.main,
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
}));

const MainApp = styled("div")`
  flex-direction: row;
  flex-grow: 1;
  overflow-x: hidden;
`;

/**
 * TODO:
 *  1 - Roles - embed on page load
 *  2 - Links to actual nodes
 *  3 - Dynamic index page and url_name detection
 */

const Layout = () => {
  return (
    <ViewPort>
      <MainApp>
        <Router />
      </MainApp>
    </ViewPort>
  );
};

export { Layout };
